var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36792 45H33.7736C37.8066 45 40 42.8285 40 38.809V14.2531C40 10.2336 37.8066 8.03901 33.6321 8.03901H28.7736C28.7736 4.01951 25.4009 0 20 0C14.6462 0 11.2736 3.95021 11.2264 8.03901H6.36792C2.1934 8.03901 0 10.1874 0 14.2531V38.809C0 42.8747 2.1934 45 6.36792 45ZM20 1.68634C24.3868 1.68634 26.9575 4.87423 27.0283 8.03901H12.9717C13.0189 4.87423 15.6132 1.68634 20 1.68634ZM6.41509 43.2906C3.34906 43.2906 1.74528 41.7197 1.74528 38.7166V14.3455C1.74528 11.3193 3.34906 9.77156 6.41509 9.77156H33.5849C36.533 9.77156 38.2311 11.3193 38.2311 14.3455V38.7166C38.2311 41.7197 36.533 43.2906 33.7264 43.2906H6.41509Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.0817f376.svg";
export { ForwardRef as ReactComponent };